import { Components } from '@mui/material'

import Fonts from '#/styles/Fonts'

export function OverridedForm(): Components {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: Fonts.fontSize.S,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: Fonts.fontSize.SS,
          marginLeft: 0,
        },
      },
    },
  }
}
